/// <reference types="./delete-result.d.ts" />
export class DeleteResult {
    #numDeletedRows;
    constructor(numDeletedRows) {
        this.#numDeletedRows = numDeletedRows;
    }
    get numDeletedRows() {
        return this.#numDeletedRows;
    }
}
Object.defineProperty(DeleteResult.prototype, 'numDeletedRows', {
    enumerable: true,
});
